import { Checkbox, Col, Form, InputNumber, Row, Select } from "antd";
import * as S from "../Multistepform.styles";
import AppartementsFormList from "../components/AppartementsFormList";
import VillasFormList from "../components/VillasFormList";
import BureauxFormList from "../components/BureauxFormList";
import CommercialsFormList from "../components/LcFormList";

interface Props {
  form: any;
  formData:any;
  setFormData: any;
  typeDeProjet: string[];
}

export const CaracteristiqueUniteesStep: React.FC<Props> = ({
  form,
  formData,
  setFormData,
  typeDeProjet,
}) => {
  
  
 

  return (
    <>
      {typeDeProjet.includes("appartements") && (
        <>
        <S.SpanLined>Appartements</S.SpanLined>
          <AppartementsFormList form={form} formData={formData} setFormData={setFormData}/>
        </>
      )}
      {typeDeProjet.includes("villas") && (
        <>
          <S.SpanLined>Villas</S.SpanLined>
          <VillasFormList form={form} formData={formData} setFormData={setFormData}/>
          
        </>
      )}

      {typeDeProjet.includes("bureaux") && (
        <>
          <S.SpanLined>Bureaux</S.SpanLined>
          <BureauxFormList form={form} formData={formData} setFormData={setFormData}/>
          
        </>
      )}
      {typeDeProjet.includes("locaux commerciaux") && (
        <>
       
          <S.SpanLined>Locaux commerciaux</S.SpanLined>
          <CommercialsFormList form={form} formData={formData} setFormData={setFormData}/>
          
        </>
      )}
    </>
  );
};
